const serviceData = [
    {
        name: "Orthopedic",
        description: "Orthopedic services provide comprehensive care for musculoskeletal conditions, employing both surgical and non-surgical approaches to enhance mobility and alleviate discomfort.",
        bgColor: "#f3ccff",
        textColor: "#9771FF",
        
    },
    {
        name: "Cardiologist",
        description: "Cardiologists offer specialized care for heart-related issues, employing diagnostic tools and treatments to optimize cardiovascular health and prevent diseases.",
        bgColor: "#FFE385",
        textColor: "#FFB60D",
    },
    {
        name: "Gastroenterologists",
        description: "Gastroenterologists provide expert care for digestive system disorders, offering diagnostics and treatments to optimize gastrointestinal health and well-being.",
        bgColor: "#B8E2F2",
        textColor: "#0067FF",
    },
    {
        name: "Pediatrician",
        description: "Pediatricians deliver specialized healthcare for children, addressing their medical needs from infancy to adolescence, promoting growth, and ensuring well-being ",
        bgColor: "#f3ccff",
        textColor: "#9771FF",
    },
    {
        name: "Psychiatrist",
        description: "Psychiatrists provide mental health care, diagnosing and treating psychiatric disorders through therapy, medication, and personalized interventions for optimal well-being.",
        bgColor: "#FFE385",
        textColor: "#FFB60D",
    },
    {
        name: "Immunologists",
        description: "Immunologists specialize in diagnosing and treating immune system disorders, aiming to strengthen immunity and manage conditions for overall health.",
        bgColor: "#B8E2F2",
        textColor: "#0067FF",
    },
]

export default serviceData;

